import React from 'react';

import {useTranslations} from 'src/components/TranslationsContext';

export default function RoleDescription() {
  const {t} = useTranslations();
  return (
    <div>
      <table className="mt-2 table-auto">
        <thead className="sr-only">
          <tr>
            <th>{t('role')}</th>
            <th>{t('description')}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="font-bold align-top pr-4">{t('ownerRole')}</td>
            <td>{t('ownerRoleDesc')}</td>
          </tr>
          <tr>
            <td className="font-bold align-top pr-4">{t('adminRole')}</td>
            <td>{t('adminRoleDesc')}</td>
          </tr>
          <tr>
            <td className="font-bold align-top pr-4">{t('regularRole')}</td>
            <td>{t('regularRoleDesc')}</td>
          </tr>
          <tr>
            <td className="font-bold align-top pr-4">{t('readonlyRole')}</td>
            <td>{t('readonlyRoleDesc')}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
